import { getUrlParamValue, IGetUrlParamValue } from './DexeroUrlHelpers/getUrlParamValue';
import { getUrlSeperator, IGetUrlSeperator } from './DexeroUrlHelpers/getUrlSeperator';
import { getUuidValueInUrl, IGetUuidValueInUrl } from './DexeroUrlHelpers/getUuidValueInUrl';
import { IModifyUrlParam, modifyUrlParam } from './DexeroUrlHelpers/modifyUrlParam';
import { IParaseURL, paraseURL } from './DexeroUrlHelpers/paraseURL';

export interface IDexeroUrlHelpers {
  getUrlParamValue: IGetUrlParamValue;
  getUrlSeperator: IGetUrlSeperator;
  getUuidValueInUrl: IGetUuidValueInUrl;
  modifyUrlParam: IModifyUrlParam;
  paraseURL: IParaseURL;
}

const DexeroUrlHelpers = {
  // Get URL Param value or false
  getUrlParamValue,

  // Get ? or & as seperator for appending arguments to an URL
  getUrlSeperator,

  // Get UUID param of URL taking into account /a/data/uuid
  getUuidValueInUrl,

  // Modify or remove a url paramter from a url string
  modifyUrlParam,

  // Parse URL Params
  paraseURL,
};

export default DexeroUrlHelpers;
